import React from 'react';

const NewArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
    >
      <path
        d="M0.600586 1L4.97589 4.50024C5.34111 4.79242 5.86006 4.79242 6.22528 4.50024L10.6006 1"
        stroke="#5F606A"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NewArrowIcon;
